<template>
  <v-main>
    <v-card class="mx-auto my-8 pa-6" outlined max-width="1200">
      <v-col cols="12" md="12">
        <p class="text-center mt-4 mb-n2 display-1">
          Selecione uma especialidade
        </p>
        <br />
        <br />
        <p>
          *Especialidades atendidas
          <v-chip class="ma-2" color="red" text-color="white"
            ><i class="fas mr-2 fa-exclamation-triangle"></i> Selecione ao menos
            1 especialidade</v-chip
          >
        </p>
        <v-row>
          <v-col cols="12" md="5">
            <v-select
              v-model="tipoClinica"
              :items="listaTipoClinica"
              outlined
              label="Tipo de Clí­nica"
              @change="acertaEspecialidades"
              item-text="valor"
              item-value="codigo"
            ></v-select>
          </v-col>
          <v-col cols="12" md="7" style="height: initial !important">
            <div v-if="tipoClinica != 1" class="ma-2" color="yellow">
              <i class="fas mr-2 fa-exclamation-triangle"></i>
              A análise do seu credenciamento será para Clínica
              {{ tipoClinica == 2 ? 'de Emergência' : 'Radiológica' }}.
            </div>
          </v-col>
        </v-row>
        <v-simple-table
          fixed-header
          class="elevation-1"
          :height="tipoClinica == 1 ? '480px' : '120px'"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th id="Especialidades3">Especialidades</th>
                <th id="idAreaDeAtuacao3">Área de atuação</th>
                <th id="idEspecialista3">Especialista</th>
                <th id="idEspaco31"
                  v-if="especialidades.find((x) => x.valorSelecionado === 'E')"
                >
                  Grau Instrução
                </th>
                <th id="ididEspaco32" v-else></th>
                <th id="idCertificado3"
                  v-if="especialidades.find((x) => x.valorSelecionado === 'E')"
                >
                  Certificado
                </th>
                <th id="ididEspaco33" v-else></th>
                <th id="ididEspaco34"></th>
              </tr>
            </thead>
            <tbody v-for="(espec, i) in especialidades" :key="'E' + i">
              <tr>
                <td>{{ espec.titulo }}</td>
                <td>
                  <v-radio-group v-model="espec.valorSelecionado"
                    ><v-radio value="AA"></v-radio
                  ></v-radio-group>
                </td>
                <td>
                  <v-radio-group
                    v-if="espec.titulo != 'Clínica Geral'"
                    @change="espec.grauInstrucao = null"
                    v-model="espec.valorSelecionado"
                    ><v-radio value="E"></v-radio
                  ></v-radio-group>
                </td>
                <td>
                  <v-select
                    v-if="espec.valorSelecionado == 'E'"
                    v-model="espec.grauInstrucao"
                    :items="listaGrauInstrucao"
                    item-text="valor"
                    item-value="codigo"
                    :rules="[obrigatorio]"
                    placeholder="*Selecione..."
                  ></v-select>
                </td>
                <td>
                  <v-file-input
                    v-if="espec.valorSelecionado == 'E'"
                    @change="convertBase64(espec)"
                    :loading="espec.loading"
                    accept="image/png, image/jpeg, image/bmp, application/pdf"
                    v-model="espec.certificado"
                    placeholder="Anexar certificado (opcional)"
                    counter
                    truncate-length="20"
                    :rules="[
                      (value) =>
                        !value ||
                        value.size < 5000000 ||
                        'Tamanho da imagem deve ser menor que 5 MB!',
                    ]"
                  />
                </td>
                <td>
                  <v-tooltip top v-if="espec.valorSelecionado != null">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="
                          espec.valorSelecionado = null;
                          espec.grauInstrucao = null;
                          espec.certificado = null;
                        "
                        icon
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <i class="fas fa-trash"></i>
                      </v-btn>
                    </template>
                    <span>Limpar</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-col md="12" cols="12" class="text-right">
          <v-btn class="mr-2" color="primary" @click="validarIndicacao"
            >Salvar</v-btn
          >
        </v-col>
      </v-col>
    </v-card>
  </v-main>
</template>

<script>
export default {
  data() {
    return {
      especialidadesCertifBase64: [],
      especialidadesGeral: this.$const.especialidadesGeral,
      especialidadesRadio: [
        {
          codigo: 14,
          titulo: 'Radiologia',
          valorSelecionado: null,
          grauInstrucao: null,
          certificado: null,
          base64: null,
          loading: false,
          incluiClinicoGeral: false,
        },
      ],
      especialidadesEmergencia: [
        {
          codigo: 18,
          titulo: 'Emergência',
          valorSelecionado: null,
          grauInstrucao: null,
          certificado: null,
          base64: null,
          loading: false,
          incluiClinicoGeral: false,
        },
      ],
      especialidades: [], //this.especialidadesGeral,
      listaGrauInstrucao: this.$const.listaGrauInstrucao,
      listaTipoClinica: [
        { codigo: 1, valor: 'Clí­nica Geral' },
        { codigo: 2, valor: 'Clí­nica de Emergência' },
        { codigo: 3, valor: 'Clí­nica de Radiologia' },
      ],
      tipoClinica: 1,
      params: {},
      servicoBancoIndicacao: '/indicacao',
    };
  },
  computed: {
    erroEspecialidade() {
      return (
        !this.especialidades.find(
          (x) => x.valorSelecionado === 'E' || x.valorSelecionado === 'AA'
        ) &&
        this.primeiraVerificacao &&
        this.mostrarEpec
      );
    },
  },
  methods: {
    acertaEspecialidades() {
      this.limparEspecialidades();
      if (this.tipoClinica == 1) {
        this.especialidades = this.especialidadesGeral;
      } else if (this.tipoClinica == 2) {
        this.especialidades = this.especialidadesEmergencia;
      } else if (this.tipoClinica == 3) {
        this.especialidades = this.especialidadesRadio;
      }
    },

    limparEspecialidades() {
      this.especialidades.forEach(function (espec) {
        espec.valorSelecionado = null;
        espec.grauInstrucao = null;
        espec.certificado = null;
      });
    },

    checkIfIsLogged() {
      let token = localStorage.getItem('cod_consultor');
      return token && this.$route.name !== 'login';
    },

    validarIndicacao() {
      this.mensagem = '';

      const document = this.params.documento;
      const dateSplit = this.params.dataNasc.split('/');

      const formatDataNasc =
        dateSplit[2] + '-' + dateSplit[1] + '-' + dateSplit[0];

      this.convertEspecComCertificadoParaBase64();
      const cdConsultor = this.checkIfIsLogged()
        ? localStorage.getItem('cod_consultor')
        : null;

      let indicacaoRequest = {
        tipoDocumento: this.params.tipoDocumento,
        documento: document,
        cep: this.params.cep,
        dataNasc: formatDataNasc,
        especialidades: this.especialidadesCertifBase64,
        cdConsultor: cdConsultor,
        novoCadastro: false,
      };

      this.$eventBus.$emit(this.$const.EVENT_SHOW_LOADING);

      this.$http
        .post(`${this.servicoBancoIndicacao}/validar`, indicacaoRequest)
        .then(() => {
          this.$router.push({
            name: 'FeedbackIndicacaoFinalizada',
            params: { decription: 'Especialidades alteradas!' },
          });
        })
        .catch((error) => {
          if (error.response.data.message) {
            this.mensagem = error.response.data.message;
          } else {
            this.mensagem = this.$msg.ERRO_INTERNO;
          }
        })
        .then(() => {
          this.$eventBus.$emit(this.$const.EVENT_REMOVE_LOADING);
        });
    },

    convertEspecComCertificadoParaBase64() {
      this.especialidadesCertifBase64 = [];
      this.especialidades.forEach((item) => {
        if (item.valorSelecionado != null) {
          this.especialidadesCertifBase64.push({
            codigo: item.codigo,
            titulo: item.titulo,
            valorSelecionado: item.valorSelecionado,
            grauInstrucao: item.grauInstrucao,
            certificado: item.base64,
            incluiClinicoGeral: item.incluiClinicoGeral,
          });
        }
      });
    },
  },
  created: function () {
    this.acertaEspecialidades();

    if (Object.keys(this.$route.params).length !== 0) {
      this.params = this.$route.params;
      this.validarIndicacao();
    } else {
      this.$router.push({ name: 'Home' });
    }
  },
};
</script>
